import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  .title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    border-bottom: 1px solid rgb(232, 232, 234);\n    font-weight: 600;\n    font-size: 16px;\n  }\n\n  .MuiPaper-root {\n    width: 50%;\n    @media (max-width: 768px) {\n      width: 80%;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled, { useTheme } from "styled-components";
import Icon from "@/components/icon/Icon";
import { Close, Sizes } from "@/components/icon/IconList";
import { Drawer } from "@mui/material";
export const MobileFilterSideSheet = (param)=>{
    let { title , children , sliderOpen , openSlider  } = param;
    const theme = useTheme();
    const onClose = ()=>{
        openSlider(false, "");
    };
    const titleComponent = /*#__PURE__*/ _jsxs("div", {
        className: "title",
        children: [
            /*#__PURE__*/ _jsx("p", {
                children: title
            }),
            /*#__PURE__*/ _jsx(Icon, {
                icon: Close,
                size: Sizes.small,
                color: theme.new.colors.sol_gray_900,
                onClick: onClose
            })
        ]
    });
    return /*#__PURE__*/ _jsxs(MobileFilterSliderWrapper, {
        anchor: "right",
        onClose: onClose,
        className: "mobile-filter-slider",
        open: sliderOpen.isOpen,
        children: [
            titleComponent,
            children
        ]
    });
};
const MobileFilterSliderWrapper = styled(Drawer).withConfig({
    componentId: "sc-2b3104a1-0"
})(_templateObject());
